import { render, staticRenderFns } from "./CreditBalance.vue?vue&type=template&id=21fadcaa&"
import script from "./CreditBalance.vue?vue&type=script&lang=js&"
export * from "./CreditBalance.vue?vue&type=script&lang=js&"
import style0 from "./CreditBalance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports